import * as Yup from 'yup';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { LegalEntityContactFormValues } from 'features/new-actor/types/legalEntityContactFormValues';
import { ValidationRules } from 'helpers/createFormConfig';
import {
  addressFieldWithoutPlaceId,
  addressValidationRules
} from '../addressValidationRules';
import { personalInformationValidationRules } from '../personalInformationValidationRules';

export const legalEntityContactValidationRules: ValidationRules<Exclude<keyof LegalEntityContactFormValues, 'id'>> =
{
  ...personalInformationValidationRules,
  ...addressValidationRules,
  // Pas de place_id exigé pour un contact d'établissement : le back ne le renvoie
  // pas et le backfill Google ne tourne que sur un champ adresse monté — un contact
  // pré-rempli (PM sélectionnée via la recherche) resterait invalide sans erreur
  // visible, bloquant la soumission du formulaire PM.
  [AddressFormFieldNames.Address]: addressFieldWithoutPlaceId,
  [LegalEntityFormFieldNames.CompanyRole]: Yup.string()
    .trim()
    .required('Ce champ est requis'),
};
